import queryString from 'query-string';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { storyBlokToken, environment },
} = getConfig();

const storyblokMiddleware = () => (next) => (action) => {
  if (!action.storyblok) return next(action);
  next({ type: `${action.type}_REQUEST` });

  const { path } = action.storyblok;
  const storyblokHost = 'https://api.storyblok.com/';
  const version = environment === 'production' ? 'published' : 'draft';
  const token = storyBlokToken;
  const storyUrl = `${storyblokHost}/v2/cdn/stories/${path}?${queryString.stringify(
    {
      token,
      version,
    },
  )}`;

  const handleResponseOrReject = (response) => {
    if (!response.ok) {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        data: { message: response.statusText },
        status: response.status,
      });
    }

    return response.json();
  };

  return fetch(storyUrl)
    .then(handleResponseOrReject)
    .then((result) => {
      if (typeof result !== 'undefined') {
        return {
          type: `${action.type}_SUCCESS`,
          payload: result,
        };
      }
      return {
        type: `${action.type}_FAILURE`,
        error: {
          status: 404,
          message: `Story Not Found "${path}"`,
        },
      };
    })
    .catch((error) => ({
      type: `${action.type}_FAILURE`,
      payload: {
        error: {
          status: error.status,
          message: `Story Not Found "${path}"`,
        },
      },
    }))
    .then(next);
};

export default storyblokMiddleware;
